module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("United States Jewry, 1776–1985, Volume I")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_FMH"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("WHY STUDY AMERICAN JEWISH HISTORY")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("II"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("THE EARLY REPUBLIC, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03"
    }
  }, [_vm._v("III"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("POLITICAL GAINS IN THE EARLY NATIONAL PERIOD")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("THE ECONOMIC LIFE OF THE AMERICAN JEW: THE TRADITIONAL ECONOMY, 1776–1840")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("THE ECONOMIC LIFE OF THE AMERICAN JEW: THE NEW ECONOMY, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("JUDAISM IN THE UNITED STATES: THE STRUCTURE, 1776–1840")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("JUDAISM IN THE UNITED STATES: LEADERSHIP, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("SOCIAL WELFARE IN THE JEWISH COMMUNITY, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("JEWISH EDUCATION AND CULTURE, 1776–1840")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("EDUCATING AMERICAN JEWISH YOUTH, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("THE GENERAL CULTURE OF THE AMERICAN JEW, 1776–1840")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("ASPECTS OF THE GENERAL CULTURE OF THE AMERICAN JEW, 1776–1840")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("REJECTION OF THE JEW: THE STATE, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("REJECTION OF THE JEW: THE PEOPLE, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("ACCEPTANCE OF THE JEW, 1776–1840")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("REFORM JUDAISM, 1776–1840")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("AMERICAN JEWRY 1776–1840: A SUMMARY AND SOME COMMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_CT"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEY ABBREVIATIONS, SYMBOLS AND SHORT TITLES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "LOM"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("MAPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "LOM1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04a#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. FIVE JEWISH COMMUNITIES, 1776.")])]), _vm._v(" "), _c('p', {
    staticClass: "LOM1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07a#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. SIXTEEN JEWISH COMMUNITIES, 1840.")])]), _vm._v(" "), _c('p', {
    staticClass: "LOM1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13a#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. FOUR STATES NOT ACCORDING JEWS FULL EQUALITY, 1840.")])]), _vm._v(" "), _c('p', {
    staticClass: "LOM"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Illustrations",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("ILLUSTRATIONS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0